import ButtonLink from '../../../../../common/components/Button/ButtonLink.js'
import Dimensions from '../../../../../common/components/Dimensions.js'
import {showConfirmMessageModal} from '../../../../../common/components/Modal/ConfirmMessageModal.js'
import Weight from '../../../../../common/components/Weight.js'
import {
  isShippedMultiboxSelector,
  shippingInfoSelector,
} from '../../../../../data/orders.js'
import {getState, useSelector} from '../../../../../store.js'
import LabelItem from './LabelItem.js'

function showShippedMultiboxSummary(orderNumber) {
  const {packages} = shippingInfoSelector(getState(), {orderNumber})

  if (!packages?.length) {
    return
  }

  showConfirmMessageModal({
    title: 'Shipped Multibox Values',
    Message: () => (
      <div>
        <p className="fs-01 lh-md margin-bottom-20">
          <strong>
            <span className="block">Multibox weight and dimensions for</span>
            <span className="block">Order {orderNumber}</span>
          </strong>
        </p>
        <table className="table margin-bottom-0">
          <thead>
            <tr>
              <th className="table__th table__th--sm divider--right w-2">
                &nbsp;
              </th>
              <th className="table__th table__th--sm fs-00">Weight</th>
              <th className="table__th table__th--sm fs-00">Dimensions</th>
            </tr>
          </thead>
          <tbody className="table__tbody table__tbody--lines">
            {packages.map(({weight, length, height, width}, index) => (
              <tr className="wrap--multibox-tr" key={index}>
                <td className="table__td v-align-middle align-center divider--right">
                  <strong className="fs-01 margin-left-5">{index + 1}</strong>
                </td>
                <td className="table__td">
                  <span className="fs-00 lh-md">
                    <Weight value={weight} />
                  </span>
                </td>
                <td className="table__td">
                  <span className="fs-00 lh-md">
                    <Dimensions length={length} height={height} width={width} />
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ),
    hideConfirm: true,
    cancelText: 'Close',
  })
}

export default function ShippedMultibox({orderNumber}) {
  const isMultibox = useSelector((state) =>
    isShippedMultiboxSelector(state, {orderNumber}),
  )

  if (!isMultibox) {
    return null
  }

  return (
    <>
      <LabelItem label="Weight">
        <ButtonLink onClick={() => showShippedMultiboxSummary(orderNumber)}>
          Multiple
        </ButtonLink>
      </LabelItem>
      <LabelItem label="Dimensions">
        <ButtonLink onClick={() => showShippedMultiboxSummary(orderNumber)}>
          Multiple
        </ButtonLink>
      </LabelItem>
    </>
  )
}
